// removed by extract-text-webpack-plugin
module.exports = {"dimensions":"_2H3AY2izKNLlzcZuELqFkn","shipping":"lPHn6UY4QlQu7B3yDU19n","buttonEdit":"_18yj341yOk7fnElQCNJh6L","buttonRemove":"_2lusd6dMOUikhsB6Ae9Ym8"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/ContainerEdit/style.scss
// module id = 1056
// module chunks = 0